import React from "react";

const Button = ({type="button", color = "warning", children, className = "", onClick, disabled = false }) => {
  const buttonStyles = {
    warning: "text-white bg-warning shadow-button-warning hover:bg-hover-warning",
    warningDisabled: "text-white shadow-button-warning bg-hover-warning",
    success: "text-dark bg-success shadow-button-success hover:bg-hover-success",
    successDisabled: "text-dark shadow-button-success bg-hover-success",
  };

  return (
    <button type={type} disabled={disabled} onClick={onClick}
      className={` py-4 font-semibold text-base rounded-2xl px-[30px] transition ${buttonStyles[ disabled ? (color + "Disabled") : color]} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
